module.exports = __webpack_public_path__ + "catalog/holes/sash-window/sash-window.mtl";